import { render, staticRenderFns } from "./vcheckbox.vue?vue&type=template&id=4b757746&scoped=true"
import script from "./vcheckbox.vue?vue&type=script&lang=js"
export * from "./vcheckbox.vue?vue&type=script&lang=js"
import style0 from "./vcheckbox.vue?vue&type=style&index=0&id=4b757746&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b757746",
  null
  
)

export default component.exports